<app-side-menu>
  <div class="items-container">
    <!-- Filtros -->
    <div class="filters-section">
      <div class="filters-row">
        <div class="filter-group">
          <label for="stockFilter" class="form-label">Filtrar por Estoque:</label>
          <select 
            id="stockFilter" 
            class="form-select" 
            [(ngModel)]="selectedStockId"
            (change)="onStockFilterChange(selectedStockId)">
            <option value="">Todos os estoques</option>
            <option *ngFor="let stock of stocks" [value]="stock.id">
              {{ stock.name }} ({{ stock.code }})
            </option>
            <!-- Debug: mostrar quantidade de estoques -->
            <option *ngIf="stocks.length === 0" disabled>Nenhum estoque encontrado</option>
          </select>
        </div>

        <div class="filter-group">
          <label for="warehouseFilter" class="form-label">Filtrar por Almoxarifado:</label>
          <select 
            id="warehouseFilter" 
            class="form-select" 
            [(ngModel)]="selectedWarehouseId"
            (change)="onWarehouseFilterChange(selectedWarehouseId)">
            <option value="">Todos os almoxarifados</option>
            <option *ngFor="let warehouse of warehouses" [value]="warehouse.id">
              {{ warehouse.name }} ({{ warehouse.code }})
            </option>
            <!-- Debug: mostrar quantidade de almoxarifados -->
            <option *ngIf="warehouses.length === 0" disabled>Nenhum almoxarifado encontrado</option>
          </select>
        </div>

        <div class="filter-group">
          <label for="statusFilter" class="form-label">Filtrar por Status:</label>
          <select 
            id="statusFilter" 
            class="form-select" 
            [(ngModel)]="selectedStatus"
            (change)="onStatusFilterChange(selectedStatus)">
            <option value="">Todos os status</option>
            <option *ngFor="let status of statusOptions" [value]="status.name">
              {{ status.name }}
            </option>
          </select>
        </div>

        <div class="filter-actions">
          <button 
            type="button" 
            class="btn btn-outline-secondary"
            (click)="clearFilters()">
            <i class="fas fa-times me-2"></i>
            Limpar Filtros
          </button>
        </div>
      </div>
    </div>

    <!-- Tabela de Itens -->
    <div *ngIf="!error">
      <app-table
        [title]="tableTitle"
        [columns]="columns"
        [data]="items"
        [loading]="loading"
        [showSearch]="showSearch"
        [searchPlaceholder]="searchPlaceholder"
        [searchTerm]="searchTerm"
        [clickable]="clickable"
        [actions]="actions"
        [itemsPerPage]="pageSize"
        [currentPageFromBackend]="currentPage"
        [totalItemsFromBackend]="totalItems"
        [hasNextPageFromBackend]="hasNextPage"
        [hasPreviousPageFromBackend]="hasPreviousPage"
        [enableSorting]="true"
        (sortChange)="onSortChange($event)"
        (searchChange)="onSearch($event)"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"
        (actionClick)="onActionClick($event)">
        <app-button
          *appHasPermission="'Items.Create'"
          table-header-action
          text="Novo Item"
          [color]="'var(--primary-light)'"
          [height]="'42px'"
          className="new-item-btn"
          (buttonClick)="newItem()">
        </app-button>
      </app-table>
    </div>

<!-- Error Message -->
    <div *ngIf="error" class="alert alert-danger" role="alert">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <i class="fas fa-exclamation-triangle me-2"></i>
          {{ error }}
        </div>
        <button 
          type="button" 
          class="btn btn-outline-danger btn-sm"
          (click)="retryLoad()">
          <i class="fas fa-redo me-1"></i>
          Tentar Novamente
        </button>
      </div>
    </div>

  </div>
</app-side-menu>
